<gmp-place-autocomplete placeholder="Find gade, by eller lign." #search class="map-search input"></gmp-place-autocomplete>

<div class="ctrls">
  <input #lattitude type="text" placeholder="Latitude" class="input" disabled />
  <input #longitude type="text" placeholder="Longitude" class="input" disabled />
  <button mat-flat-button color="primary" type="button" title="Overfør til formular" (click)="approveLocation()">
    <span>Overfør til formular</span>
  </button>
</div>

@if (mapLoadAllowed()) {
  <google-map
    height="800px"
    width="1224px"
    mapId="address-locator"
    [options]="options()!"
    (mapClick)="addMarker($event)"
    (mapInitialized)="onMapReady($event)"
    #mapInstance="googleMap">
    @if (currentMarker()?.position) {
      <map-marker #markerElem="mapMarker" [position]="currentMarker()!.position!"></map-marker>
    }
  </google-map>
}
